import { connect } from "react-redux";
import SilRooms from "./SilRooms";
import {
  deleteSilRoomRequest,
  fetchAllSilRoomsListRequest,
  setSelectedSilAccommodationRoomVacantLocally,
} from "store/actions/sil.actions";
import {
  getSelectedSilAccommodationRooms,
  getSilAccommodationRoomListLoading,
} from "store/selector/sil.selector";
import { getSPParticipantsListRequest } from "store/actions/sp.actions";
import {
  getParticipantsList,
  getSpParticipantsListLoading,
} from "store/selector/sp.selector";

const mapDispatchToProps = {
  fetchAllSilRoomsListRequest,
  deleteSilRoomRequest,
  setSelectedSilAccommodationRoomVacantLocally,
  getSPParticipantsListRequest,
};

const mapStateToProps = (state) => {
  const silAccommodationRoomListLoading =
    getSilAccommodationRoomListLoading(state);
  const selectedSilAccommodationRooms = getSelectedSilAccommodationRooms(state);

  const spParticipantsList = getParticipantsList(state);
  const spParticipantsListLoader = getSpParticipantsListLoading(state);

  return {
    selectedSilAccommodationRooms,
    silAccommodationRoomListLoading,
    spParticipantsListLoader,
    spParticipantsList,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SilRooms);
